import _extends from "@babel/runtime/helpers/extends";

/*
 * @Author: wangshengqiang
 * @Date: 2021-04-25 10:29:18
 * @LastEditTime: 2022-01-12 16:53:06
 * @LastEditors: wangshengqiang
 * @Description: bu jing zhi
 */
import React from 'react';
import { Stepper } from 'zarm';
import { FormItem } from '@/baseComponents';
import './index.less';
export default function RowStepper(props) {
  const {
    label,
    remark = {},
    formKey,
    radioType = 'button',
    minValue,
    maxValue,
    stepValue,
    disabled,
    isBenefitFactor,
    isPremiumFactor
  } = props;
  const formItemProps = {
    label,
    remark,
    name: formKey,
    fieldOption: {
      isBenefitFactor,
      isPremiumFactor,
      initialValue: minValue
    }
  };
  return /*#__PURE__*/React.createElement(FormItem, _extends({}, props, formItemProps), /*#__PURE__*/React.createElement(Stepper, {
    className: "stepper-container",
    radioType: radioType,
    disabled: disabled,
    min: minValue,
    max: maxValue,
    step: stepValue,
    shape: "rect"
  }));
}